import { Component, OnInit, OnDestroy } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { ChartPart } from 'src/app/models/chart.model'
import { getChartAmazon, getLoading, getLoaded } from 'src/app/selectors/chart.selector'
import { Observable, Subscription } from 'rxjs'
import { MediaObserver, MediaChange } from '@angular/flex-layout'
import {
  getDataCollectByChartsAmazon,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-chart-item-amazon',
    templateUrl: './chart-item-amazon.component.html',
    styleUrls: ['./chart-item-amazon.component.scss'],
    standalone: false
})
export class ChartItemAmazonComponent implements OnInit, OnDestroy {
  amazonInfo$: Observable<ChartPart[]>
  loading$: Observable<boolean>
  loaded$: Observable<boolean>
  allEmpty$: Observable<boolean>
  period$: Observable<any>
  private subscriptions: Subscription[] = []
  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(public media: MediaObserver, private store: Store<AppState>) {
    this.subscriptions.push(media.asObservable().subscribe(() => {}))
  }

  ngOnInit() {
    this.amazonInfo$ = this.store.select(getChartAmazon)
    this.loading$ = this.store.select(getLoading)
    this.loaded$ = this.store.select(getLoaded)

    this.dataCollections$ = this.store.select(getDataCollectByChartsAmazon)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }

  ngOnDestroy() {
    this.subscriptions.forEach(it => it.unsubscribe())
  }
}
